/**
 * @generated SignedSource<<ea01aa37d0819bb97bf7d5c622220bb3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PrivacyCookieConsent_platform",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cookieConsentBannerReadMoreTargetPageSlug",
      "storageKey": null
    }
  ],
  "type": "Platform",
  "abstractKey": null
};

node.hash = "a1922f55db942f6fedd8d25f5561bb13";

module.exports = node;
